import React from "react"
import { Floor } from "../FloorStyled"
import { Button, SFXS } from "@orbital/games-frontend-library"
import { ReactComponent as AutoSVG } from "./auto.svg"
import { ReactComponent as RefreshSVG } from "./refresh.svg"

export default function ThirdFloor({
  stake,
  handleAbove,
  handleClear,
  placeBet,
  footerState,
  handleNotification,
  audio,
  handleModal,
}: any) {
  return (
    <Floor>
      <Button
        customClass={stake === "0.10" && "disable"}
        textColor="#181731"
        func={(e?: boolean) => e && handleClear()}
        SFX={SFXS.divideSFX}
        handleNotification={handleNotification}
        audio={audio}
      >
        <RefreshSVG />
      </Button>
      <Button
        width="164px"
        textColor="#181731"
        func={(b: boolean) => b && placeBet(stake)}
        SFX={SFXS.playSFX}
        customClass={footerState === "disabled" && "disable"}
        audio={audio}
      >
        PLAY
      </Button>
      <Button
        textColor="#181731"
        SFX={SFXS.goForwardSFX}
        func={(b: boolean) => {
          b && handleModal("auto")
        }}
        audio={audio}
      >
        <AutoSVG />
      </Button>
    </Floor>
  )
}
